module.exports = __webpack_public_path__ + "74618f0a3dea19a400439a64a297bc2b.svg";